import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowRight, Loader2 } from "lucide-react";
import { AuthShell, Field } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "customer" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function set(k, v) { setForm((f) => ({ ...f, [k]: v })); }

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(form);
    setLoading(false);
    if (!res.ok) { setError(res.error); return; }
    if (res.user.role === "staff") navigate("/staff");
    else navigate("/app");
  }

  return (
    <AuthShell title="Konto erstellen" subtitle="Loyalty, Favoriten & Historie freischalten.">
      <form onSubmit={onSubmit} className="space-y-4" data-testid="register-form">
        <Field label="Name" value={form.name} onChange={(v) => set("name", v)} testid="register-name-input" required />
        <Field label="E-Mail" type="email" value={form.email} onChange={(v) => set("email", v)} testid="register-email-input" required />
        <Field label="Passwort" type="password" value={form.password} onChange={(v) => set("password", v)} testid="register-password-input" required minLength={4} />

        <div>
          <span className="text-xs tracking-[0.15em] uppercase text-[#A1A1AA] mb-2 block">Rolle</span>
          <div className="grid grid-cols-2 gap-3">
            {[
              { v: "customer", l: "Gast" },
              { v: "staff", l: "Service" },
            ].map((opt) => (
              <button
                key={opt.v} type="button" onClick={() => set("role", opt.v)} data-testid={`register-role-${opt.v}`}
                className={`px-4 py-3 rounded-xl border text-sm font-semibold transition-all ${
                  form.role === opt.v
                    ? "border-[#EBB300] bg-[#EBB300]/10 text-[#EBB300]"
                    : "border-white/10 bg-[#0A0A0C] text-[#A1A1AA] hover:border-white/20"
                }`}
              >{opt.l}</button>
            ))}
          </div>
          <p className="text-xs text-[#52525B] mt-2">Admins werden per Backend-Seed angelegt.</p>
        </div>

        {error && <div className="text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/20 rounded-lg px-3 py-2" data-testid="register-error">{error}</div>}

        <button type="submit" disabled={loading} data-testid="register-submit-button"
          className="w-full mt-2 inline-flex justify-center items-center gap-2 px-6 py-3.5 rounded-full bg-[#EBB300] text-[#0A0A0C] font-bold hover:bg-[#FAD02C] transition-colors disabled:opacity-60 gold-glow">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Konto erstellen <ArrowRight className="w-4 h-4" /></>}
        </button>
      </form>
      <div className="mt-6 text-sm text-[#A1A1AA] text-center">
        Schon registriert? <Link to="/login" className="text-[#EBB300] hover:underline" data-testid="register-to-login-link">Anmelden</Link>
      </div>
    </AuthShell>
  );
}
